import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';


export const assignBulkAchievement = createAsyncThunk(
    'achievements/assignBulkAchievement',
    async (bulkData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.ACHIEVEMENTS.ASSIGN_BULK, bulkData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const addAchievement = createAsyncThunk(
    'achievements/addAchievement',
    async (bulkData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.ACHIEVEMENTS.CREATE, bulkData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getAchievements = createAsyncThunk(
    'achievements/getAchievements',
    async ({ studentId }, thunkAPI) => {
        try {
            const response = await client.get(`${ENDPOINTS.ACHIEVEMENTS.GET_BY_ID.replace(':id', studentId)}`, {
                token: thunkAPI.getState().auth.token
            });
            return response.data || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deleteAchievement = createAsyncThunk(
    'achievements/deleteAchievement',
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.ACHIEVEMENTS.DELETE.replace(':id', id),{}, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);


const initialState = {
    achievements: [],
    loading: false,
    error: null
};

const achievementsSlice = createSlice({
    name: 'achievements',
    initialState,
    reducers: {
        clearAchievements: (state) => {
            state.achievements = [];
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(assignBulkAchievement.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(assignBulkAchievement.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(assignBulkAchievement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addAchievement.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addAchievement.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addAchievement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getAchievements.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAchievements.fulfilled, (state, action) => {
                state.loading = false;
                state.achievements = action.payload.items || [];
            })
            .addCase(getAchievements.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteAchievement.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteAchievement.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteAchievement.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { clearAchievements, clearError } = achievementsSlice.actions;
export default achievementsSlice.reducer; 